export class InputHistory {
  private history: string[] = [];
  private index = -1;
  private draft = "";

  push(value: string) {
    if (!value) {
        return;
    }
    
    value = value.trim();

    if (!value) {
        return;
    }   

    // Remove existing occurrence, then append — keeps it an ordered set
    const existing = this.history.indexOf(value);
    if (existing !== -1) {
      this.history.splice(existing, 1);
    }

    this.history.push(value);
    this.index = -1;
    this.draft = "";
  }

  up(currentValue: string): string | null {
    if (this.history.length === 0) return null;

    if (this.index === -1) {
      this.draft = currentValue;
    }

    if (this.index < this.history.length - 1) {
      this.index++;
    }

    return this.history[this.history.length - 1 - this.index];
  }

  down(): string | null {
    if (this.index <= 0) {
      this.index = -1;
      return this.draft;
    }

    this.index--;
    return this.history[this.history.length - 1 - this.index];
  }
}